import { ref } from 'vue';
import ApiService from '@/core/services/api.service';
import { xoa_dau } from '@/utils/common';

export default function useEmployeeSearch(options = {}) {
  const { form } = options;

  const employees = ref([]);
  const filteredEmployees = ref([]);
  const isLoading = ref(false);

  const searchQuery = ref('');

  const loadEmployees = async () => {
    if (employees.value.length > 0) return;
    try {
      isLoading.value = true;
      const response = await ApiService.get('/v1/employees');
      const { dataset = [] } = response?.data?.data || {};

      employees.value = dataset.map((employee) => {
        const { id, fullName, code } = employee;
        let suggestionName = fullName;

        if (code) {
          suggestionName += ` (${code})`;
        }

        return {
          id,
          name: fullName,
          code: code || '',
          suggestionName,
          nameNoneSign: xoa_dau(fullName),
        };
      });

      filteredEmployees.value = [...employees.value];
      isLoading.value = false;
    } catch (error) {
      console.error('Failed to load employees:', error);
      isLoading.value = false;
    }
  };

  const filterEmployees = (query = '') => {
    searchQuery.value = query;

    if (!query.trim()) {
      filteredEmployees.value = [...employees.value];
      return;
    }

    const lowercaseQuery = query.toLowerCase();

    filteredEmployees.value = employees.value.filter((employee) => {
      return (
        employee.nameNoneSign.toLowerCase().includes(lowercaseQuery) ||
        employee.name.toLowerCase().includes(lowercaseQuery) ||
        employee.code.toLowerCase().includes(lowercaseQuery)
      );
    });
  };

  const selectEmployee = (employee) => {
    if (!form) return;

    form.inChargeEmployeeId = employee.id;
    form.inChargeEmployeeName = employee.name;
    searchQuery.value = employee.name;
  };

  const initFromForm = async () => {
    if (!form || !form.inChargeEmployeeId) return;

    await loadEmployees();

    const employee = employees.value.find(
      (emp) => emp.id === form.inChargeEmployeeId,
    );
    if (employee) {
      form.inChargeEmployeeName = employee.name;
      searchQuery.value = employee.name;
    }
  };

  loadEmployees();

  if (form && form.inChargeEmployeeId) {
    initFromForm();
  }

  return {
    employees,
    filteredEmployees,
    searchQuery,
    isLoading,
    loadEmployees,
    filterEmployees,
    selectEmployee,
  };
}
